import { Box, Text, BoxProps } from '@chakra-ui/react';
import { trioUITheme } from '@/styles/theme';

type ChartEmptyStateProps = BoxProps & {
  title: string;
  subTitle: string;
};

const ChartEmptyState = ({ title, subTitle, ...props }: ChartEmptyStateProps): JSX.Element => (
  <Box
    data-testid="chart-empty-state"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    {...props}
  >
    <Text
      textAlign="center"
      fontWeight={600}
      fontSize={18}
      color={trioUITheme.colors['neutral-50']}
      mb="16px"
    >
      {title}
    </Text>
    <Text textAlign="center" fontSize={14} color={trioUITheme.colors['neutral-90']}>
      {subTitle}
    </Text>
  </Box>
);

export default ChartEmptyState;
